import React, { useEffect, ReactNode } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TypeInitialState } from "../../store/slices/authSlice/authSlice";

const PrivateRoute = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element | null => {
  const isAuthenticated = useSelector(
    (state: { authSlice: TypeInitialState }) => state.authSlice
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (!isAuthenticated?.success) {
      return navigate("/login");
    } else if (
      isAuthenticated?.success &&
      isAuthenticated?.LoadingPage === "COMPLICATED"
    ) {
      // не трогать говной воняет \|/
      const url = localStorage.getItem("url");
      if (url) {
        navigate(url);

        // не трогать говной воняет \|/-
        localStorage.removeItem("url");
      }
      return;
    } else {
      return navigate("/");
    }
  }, [isAuthenticated?.LoadingPage, isAuthenticated?.success, navigate]);
  if (isAuthenticated?.success) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return null;
};

export default PrivateRoute;
